<ph-dialog [open]="open" size="sm" [heading]="'Invoice details' + headerText" (ph-close)="closeDialog()">
    <app-payable-review
        [payable]="payable"
        [useContainer]="false"
        [displayDisclaimer]="false"
    >
    </app-payable-review>
    <ph-button icon="download-simple" [disabled]="isDownloading" (click)="downloadCheck()">Download check and mark as paid</ph-button>
</ph-dialog>
